import React from 'react';

// helpers
import { format, parseISO } from 'date-fns';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

// constants
import {
    ActivityLogModelName,
    ActivityLogTypeName,
    ActivtyLog,
} from 'models/activty-log.model';

type AuditTrailContentProps = {
    data: ActivtyLog[];
    date: string;
};

const AuditTrailContent: React.FC<
    React.PropsWithChildren<AuditTrailContentProps>
> = ({ data, date }) => {
    return (
        <LogList key={date}>
            {[...data]
                .sort(
                    (a, b) =>
                        new Date(b.created_at).getTime() -
                        new Date(a.created_at).getTime(),
                )
                .map((log) => (
                    <LogEntry key={log.id}>
                        <EntryText>
                            {ActivityLogModelName[log.object_type] ||
                                log.object_type}{' '}
                            {ActivityLogTypeName[log.verb] || log.verb} by{' '}
                            {log.user_name}
                        </EntryText>
                        <EntryTime>
                            {format(parseISO(log.created_at), 'hh:mm a')}
                        </EntryTime>
                    </LogEntry>
                ))}
        </LogList>
    );
};

const LogList = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(5),
    borderLeft: `1px solid ${aampeTheme.colors.interactiveWG01}`, // vertical line
    padding: aampeTheme.spacing4(1),
    marginLeft: aampeTheme.spacing4(2),
});

const LogEntry = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(2),
    paddingLeft: aampeTheme.spacing4(1),
});

const EntryText = styled.div({
    fontSize: aampeTheme.size.font.default,
    fontWeight: 500,
    color: aampeTheme.colors.gray800,
    lineHeight: aampeTheme.size.lineHeight.small,
});

const EntryTime = styled.div({
    fontSize: aampeTheme.size.font.textMedium,
    fontWeight: 400,
    color: aampeTheme.colors.textAccessibleWG01,
});

export default AuditTrailContent;
